import './design/globals.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AppProviders } from './app/providers'
import { AppRouter } from './app/router'
import { session } from './auth'
import { bootstrapBrand } from './brand'
import { installDevHooks } from './dev-hooks'
import { installErrorTelemetry } from './lib/telemetry'

const root = document.getElementById('root')
if (root === null) throw new Error('#root missing from index.html')

// Dev server only: compile-time false in every build, so the hooks are tree-shaken out of `dist`.
if (import.meta.env.DEV) installDevHooks()

// Brand first (public, cached per host), session second (refresh cookie). Neither blocks render:
// the SessionGate shows a neutral splash until the session status is known.
installErrorTelemetry()
void bootstrapBrand()
void session.bootstrap()

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
)
